import Loading from '@Web/Src/UI/Loading';

const SimpleSwiperLazy = () => {
    return (
        <div className='relative h-max w-full overflow-hidden text-center'>
            <Loading type={'ellipsis'} />
        </div>
    );
};

export default SimpleSwiperLazy;
